import { searchFromResort, searchFromPrefecture, searchFromArea} from './SearchHelper';
import { SnowItemResortCandidateHash, PrefectureCandidateHash, AreaCandidateHash } from '../../types'
import { IItemSuggestion } from '../../types';

function searchSnowItemFromResort(keyword: string, locale: string, resortCandidates: SnowItemResortCandidateHash, prefectureCandidates: PrefectureCandidateHash, areaCandidates: AreaCandidateHash): IItemSuggestion[] {
  return searchFromResort(keyword, locale, resortCandidates, prefectureCandidates, areaCandidates).map( resultJson =>
    <IItemSuggestion>{
      type: 'resort',
      id: resultJson['code'],
      label: resultJson['name'][locale],
      lift_count: resultJson['lift_count'],
      lesson_count: resultJson['lesson_count'],
      rental_count: resultJson['rental_count'],
      total_count: resultJson['total_count']
    } 
  )
}

function searchSnowItemFromPrefecture(keyword: string, locale: string, prefectureCandidates: PrefectureCandidateHash): IItemSuggestion[] {
  return searchFromPrefecture(keyword, locale, prefectureCandidates).map( resultJson =>
    <IItemSuggestion>{
      type: 'prefecture',
      id: resultJson['code'],
      label: resultJson['name'][locale],
      lift_count: resultJson['lift_count'],
      lesson_count: resultJson['lesson_count'],
      rental_count: resultJson['rental_count'],
    }
  )
}

function searchSnowItemFromArea(keyword: string, locale: string, areaCandidates: AreaCandidateHash): IItemSuggestion[] {
  return searchFromArea(keyword, locale, areaCandidates).map( resultJson =>
    <IItemSuggestion>{
      type: 'area',
      id: resultJson['code'],
      label: resultJson['name'][locale],
      lift_count: resultJson['lift_count'],
      lesson_count: resultJson['lesson_count'],
      rental_count: resultJson['rental_count'],
    }
  )
}

export {
  searchSnowItemFromResort,
  searchSnowItemFromPrefecture,
  searchSnowItemFromArea,
};
